<template>
  <div>
    <v-btn 
      :disabled="disabled" 
      color="primary" 
      :loading="loading" 
      @click="getExcel" 
      text
      class="font-weight-black text-uppercase tracking-widest rounded-lg px-4 transition-fast-in-fast-out h-44"
    >
      <v-icon left size="16">fas fa-file-excel</v-icon>
      Exportar
    </v-btn>
  </div>
</template>

<script>
import notifications from '@/utils/notifications'
import { excelRelbaseProductBillingReport } from '@/api/relbase'
import moment from 'moment'

export default {
  name: "ExportRelbaseProductBillingReport",
  props: {
    filter: { type: Object, default: () => ({}) },
    options: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
    search: { type: String, default: "" }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    async getExcel() {
      if (!this.filter.date_after && !this.filter.date_before) {
        notifications.showError('Selecciona al menos una fecha para exportar el reporte')
        return
      }
      this.loading = true

      const { sortBy, sortDesc } = this.options
      const sortField = (sortBy && sortBy.length) ? sortBy[0] : 'total_bruto'
      const ordering = (sortDesc && sortDesc[0]) ? `-${sortField}` : sortField
      
      const params = new URLSearchParams({
        date_emited_after: this.filter.date_after || '',
        date_emited_before: this.filter.date_before || '',
        customer: this.filter.customer || '',
        seller: this.filter.seller || '',
        sku: this.filter.sku || '',
        category: this.filter.category || '',
        search: this.search || '',
        ordering: ordering
      })
      
      await excelRelbaseProductBillingReport(params.toString())
        .then((response) => {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(response);
          link.setAttribute('download', `relbase_ventas_producto_${moment().format('DD-MM-YYYY_HHmm')}.xlsx`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          notifications.showSuccess('Reporte de ventas generado')
        })
        .catch(() => {
          notifications.showError('Error al exportar reporte de ventas por producto')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.h-44 { height: 44px !important; }
.tracking-widest { letter-spacing: 1.5px; }
</style>
